import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import { Link } from 'react-router-dom';
import QuickActionCard from '../componets/common/QuickActionCard';
import ContentEditRow from '../componets/common/ContentEditRow';
import EventRow from '../componets/common/EventRow';
import FeedbackRow from '../componets/common/FeedbackRow';
import SupportRow from '../componets/common/SupportRow';
import './home.css';
import heroo from '../asserts/hero.png';
import { supabase } from '../supabaseClient';
import Preloader from '../componets/layout/preloader';

const Home = () => {
    const [events, setEvents] = useState([]);
    const [feedbacks, setFeedbacks] = useState([]);
    const [supportMessages, setSupportMessages] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const { data: evs } = await supabase
                .from('events')
                .select('*');

            const { data: feedback } = await supabase
                .from('eventfeedback')
                .select('*, user_name, events(title_en)');

            const { data: support } = await supabase
                .from('supportmessages')
                .select('*, users(full_name, email)')
                .eq('status', 'New');

            if (evs) setEvents(evs);
            if (feedback) setFeedbacks(feedback);
            if (support) setSupportMessages(support);
        };
        getData();
    }, []);

    return (

        <>
                    <Preloader />

            <DashLayout title="Dashboard Overview" active="dashboard">

<div className="hov-welcome-banner">
    <div className="hov-welcome-text">
        <h1 className="hov-welcome-title">Welcome to <span className="hov-brand">FoxEvents</span> CMS</h1>
        <p className="hov-welcome-sub">Manage your event booking platform and website content.</p>
    </div>
    <img className='heroo' src={heroo} alt="" />
</div>

<div className="hov-stats-row">
    <div className="hov-stat-box">
        <div className="hov-stat-top">
            <div className="hov-stat-icon hov-stat-pink">
               <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M7 2v3M13 2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
            </div>
        </div>
        <p className="hov-stat-title">Total Events</p>
        <p className="hov-stat-number">156</p>
        <p className="hov-stat-sub">48 published, 8 draft</p>
    </div>

    <div className="hov-stat-box">
        <div className="hov-stat-top">
            <div className="hov-stat-icon hov-stat-purple">
            <svg
  className="dash-nav-icon"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 7a2 2 0 012-2h12a2 2 0 012 2v3a2 2 0 000 4v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3a2 2 0 000-4V7z"
    stroke="currentColor"
    strokeWidth="1.5"
  />
  <path
    d="M9 12h6"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />
</svg>
            </div>
        </div>
        <p className="hov-stat-title">Total Bookings</p>
        <p className="hov-stat-number">1,284</p>
        <p className="hov-stat-sub">234 this month</p>
    </div>

    <div className="hov-stat-box">
        <div className="hov-stat-top">
            <div className="hov-stat-icon hov-stat-blue">
               <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
            </div>
        </div>
        <p className="hov-stat-title">Platform Users</p>
        <p className="hov-stat-number">3,492</p>
        <p className="hov-stat-sub">487 new this month</p>
    </div>

    <div className="hov-stat-box">
        <div className="hov-stat-top">
            <div className="hov-stat-icon hov-stat-indigo">
            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 5h14M3 10h10M3 15h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
            </div>
        </div>
        <p className="hov-stat-title">Event Categories</p>
        <p className="hov-stat-number">7</p>
        <p className="hov-stat-sub">All active</p>
    </div>
</div>

                <div className="hov-section">
                    <div className="hov-section-header">
                        <div className="hov-section-title-wrap">
                            <svg className="hov-section-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 2l2.09 4.26L17 7.27l-3.5 3.41.83 4.82L10 13.27l-4.33 2.23.83-4.82L3 7.27l4.91-.71L10 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                            </svg>
                            <p className="hov-section-title">Quick Actions</p>
                        </div>
                    </div>
                    <div className="hov-quick-actions">
                        <Link to="/events" className="no-underline-link">
                            <QuickActionCard label="Add New Event" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/><path d="M7 2v3M13 2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M10 11v4M8 13h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        </Link>
                        <Link to="/sections" className="no-underline-link">
                            <QuickActionCard label="Edit Sections" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5z" stroke="currentColor" strokeWidth="1.5"/><path d="M2 13a2 2 0 012-2h5a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2z" stroke="currentColor" strokeWidth="1.5"/><path d="M13 13a2 2 0 012-2h1a2 2 0 012 2v2a2 2 0 01-2 2h-1a2 2 0 01-2-2v-2z" stroke="currentColor" strokeWidth="1.5"/></svg>} />
                        </Link>
                        <Link to="/bookings" className="no-underline-link">
                            <QuickActionCard label="Manage Bookings" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h12a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5"/><path d="M7 9h6M7 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        </Link>
                        <Link to="/reviews" className="no-underline-link">
                            <QuickActionCard label="Edit Testimonials" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h12a1 1 0 011 1v8a1 1 0 01-1 1H6l-3 3V5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M7 8h6M7 11h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        </Link>
                    </div>
                </div>

                <div className="hov-grid">
                    <div className="hov-card">
                        <div className="hov-section-header">
                            <div className="hov-section-title-wrap">
                                <svg className="hov-section-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 13.5L7.5 10 10 12.5l3-3.5 3 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <p className="hov-section-title">Recent Content Edits</p>
                            </div>
                            <span className="hov-view-all">View All</span>
                        </div>
                        <ContentEditRow title="Hero Section" sub="Updated headline text" time="2 hours ago" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="5" width="16" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M6 9h8M6 12h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        <ContentEditRow title="Featured Event" sub="Updated cover image & tags" time="5 hours ago" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/><path d="M7 2v3M13 2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        <ContentEditRow title="Upcoming Events" sub="Added a new event" time="1 day ago" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/><path d="M10 11v4M8 13h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        <ContentEditRow title="Testimonials" sub="Published 3 new reviews" time="2 days ago" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h12a1 1 0 011 1v8a1 1 0 01-1 1H6l-3 3V5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>} />
                        <ContentEditRow title="New Booking Received" sub="BK-7724 confirmed for Startup Pitch Night" time="3 days ago" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h12a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5"/><path d="M7 9h6M7 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                        <ContentEditRow title="User Registered" sub="New customer account created" time="4 days ago" icon={<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5"/><path d="M3 17c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>} />
                    </div>

                    <div className="hov-card">
                        <div className="hov-section-header">
                            <div className="hov-section-title-wrap">
                                <svg className="hov-section-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                    <path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/>
                                    <path d="M7 2v3M13 2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                                <p className="hov-section-title">Recent Events</p>
                            </div>
                            <span className="hov-view-all">View All</span>
                        </div>
                        {events.map((item) => (
                            <EventRow
                                key={item.id}
                                title={item.title_en}
                                date={item.date}
                                badge={item.status}
                                badgeType={item.status === 'Published' ? 'published' : 'draft'}
                            />
                        ))}
                    </div>
                </div>

                <div className="hov-grid">
                    <div className="hov-card">
                        <div className="hov-section-header">
                            <div className="hov-section-title-wrap">
                                <svg className="hov-section-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 2l2.09 4.26L17 7.27l-3.5 3.41.83 4.82L10 13.27l-4.33 2.23.83-4.82L3 7.27l4.91-.71L10 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                </svg>
                                <p className="hov-section-title">Recent Feedback</p>
                            </div>
                            <span className="hov-view-all">View All</span>
                        </div>
                        {feedbacks.map((item) => (
                            <FeedbackRow
                                key={item.id}
                                name={item.user_name}
                                event={item.events?.title_en}
                                text={item.comment_en}
                             
                            />
                        ))}
                    </div>

                    <div className="hov-card">
                        <div className="hov-section-header">
                            <div className="hov-section-title-wrap">
                                <svg className="hov-section-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 4h12a1 1 0 011 1v8a1 1 0 01-1 1H6l-3 3V5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                </svg>
                                <p className="hov-section-title">Unresolved Support</p>
                            </div>
                            <span className="hov-view-all">View All</span>
                        </div>
                        {supportMessages.map((item) => (
                            <SupportRow
                                key={item.id}
                                name={item.users?.full_name}
                                email={item.users?.email}
                                message={item.message_en}
                                time={item.created_at}
                            />
                        ))}
                    </div>
                </div>

            </DashLayout>
        </>
    );
};

export default Home;